var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.storyRespId}},[_c('InternalPage',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.storyResp),expression:"storyResp"}],attrs:{"body":_vm.storyResp.body}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }